import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    // Set 15 minute countdown from component mount
    const startTime = Date.now();
    const duration = 15 * 60 * 1000; // 15 minutes in milliseconds
    const updateTimer = () => {
      const now = Date.now();
      const elapsed = now - startTime;
      const remaining = Math.max(0, duration - elapsed);
      if (remaining > 0) {
        setTimeLeft({
          minutes: Math.floor(remaining / (1000 * 60)),
          seconds: Math.floor(remaining % (1000 * 60) / 1000)
        });
      } else {
        setTimeLeft({
          minutes: 0,
          seconds: 0
        });
      }
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex items-center justify-center gap-1 md:gap-2" data-id="element-27">
      <TimeUnit value={timeLeft.minutes} data-id="element-28" />
      <span className="text-[#E4D6B5] text-base md:text-lg font-black" data-id="element-29">:</span>
      <TimeUnit value={timeLeft.seconds} data-id="element-30" />
    </div>;
}
function TimeUnit({
  value
}: {
  value: number;
}) {
  return <div className="bg-[#111111] border-2 border-[#6F6F6F] px-2 md:px-3 py-1 md:py-2 min-w-[35px] md:min-w-[45px] shadow-[0_2px_0_0_#6F6F6F]" data-id="element-31">
      <span className="text-lg md:text-xl font-black text-[#8B5A2B] drop-shadow-[0_2px_4px_rgba(0,0,0,0.9)]" data-id="element-32">
        {String(value).padStart(2, '0')}
      </span>
    </div>;
}